import { RED_LIGHTEST, ORANGE_LIGHT, GREEN_SOFT } from 'ui/constants'

export const SIDEBAR_WIDTH = '280px'
export const HEADER_HEIGHT = '77px'

const styles = {
  tableOffset: 320,
  tableMedicationsOffset: 300,
  tableMediumOffset: 355
}

export const LOW_RISK_BTN_STYLE = {
  color: GREEN_SOFT
}
export const MEDIUM_RISK_BTN_STYLE = {
  color: ORANGE_LIGHT
}
export const HIGH_RISK_BTN_STYLE = {
  color: RED_LIGHTEST
}

export default styles

// The offsets above take into account all the space taken up by headers,
// offsets, and filters. Filter bar height may vary, hence several vars.
// Made to fit screens 1920px-wide, the smaller resolutions will still
// display a scrollbar
